export const becomeMember = "Transform with Vasana";

export const bannerdesc =
  "Understand yourself, understand others, and thrive together.";

export const userInfoTitle = "Help Us Personalise Your Experience";
export const userInfoBannerDesc =
  "Help us tailor your Vasana journey for a personalized experience.";
